import { create } from 'zustand';
import { LEDGER_CHANNEL, type LedgerEntry } from '@/lib/network-ledger';

interface LedgerStore {
  readonly entries: readonly LedgerEntry[];
}

/** Network activity reported by the page and every worker during this visit. */
export const useLedgerStore = create<LedgerStore>()(() => ({ entries: [] }));

/** Starts listening for ledger reports; call once at startup. */
export function listenToLedger(): void {
  if (typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel(LEDGER_CHANNEL);
  channel.onmessage = (event: MessageEvent<LedgerEntry>) => {
    useLedgerStore.setState((state) => ({ entries: [...state.entries, event.data] }));
  };
}
